/*
   uploaders filter a user's file selection by file extension. 
   For example, that the file ends in .png. 
   
   We then check the file's contentType to verify that matches.
*/

/* 
  video uploader 
  make sure to set both allowedVideoTypes and allowedVideoFileExtensions
*/

export const allowedVideoTypes = {
  "video/quicktime": true,
  "video/mp4": true,
};

// dot in the file extension is required
export const allowedVideoFileExtensions = {
  ".mp4": true,
  ".mov": true,
};

export const allowedVideoFileExtensionsByKey = Object.keys(
  allowedVideoFileExtensions
).join(", ");

/* 
  image uploader 
  make sure to set both allowedVideoTypes and allowedVideoFileExtensions
*/

export const allowedImageTypes = {
  "image/png": true,
  "image/jpeg": true,
  "image/gif": true,
  "image/webp": true,
  "image/heic": true,
};

// dot in the file extension is required
export const allowedImageFileExtensions = {
  ".png": true,
  ".jpg": true,
  ".jpeg": true,
  ".gif": true,
  ".webp": true,
  ".heic": true,
};

export const allowedImageFileExtensionsByKey = Object.keys(
  allowedImageFileExtensions
).join(", ");

/* 
  document uploader 
  make sure to set both allowedDocumentTypes and allowedDocumentFileExtensions
*/

export const allowedDocumentTypes = {
  "application/pdf": true,
  "application/msword": true,
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
    true,
};

// dot in the file extension is required
export const allowedDocumentFileExtensions = {
  ".pdf": true,
  ".doc": true,
  ".docx": true,
};

export const allowedDocumentFileExtensionsByKey = Object.keys(
  allowedDocumentFileExtensions
).join(", ");

/* 
  image and video uploader in one 
  just merges image and video together
*/

export const allowedFileTypes = Object.assign(
  allowedVideoTypes,
  allowedImageTypes,
  allowedDocumentTypes
);

export const allowedFileExtensions = Object.assign(
  allowedVideoFileExtensions,
  allowedImageFileExtensions
);
export const allowedFileExtensionsByKey = Object.keys(
  allowedFileExtensions
).join(", ");

/*
  Multipart upload thresholds for Upload-First pattern
  Matches backend configuration (tfa/core/models/upload_ticket.py)
*/

// Files larger than 100MB should use multipart upload
export const MULTIPART_THRESHOLD = 100 * 1024 * 1024; // 100MB

// Each chunk should be 10MB (matches backend chunk size)
export const MULTIPART_CHUNK_SIZE = 10 * 1024 * 1024; // 10MB

// Number of chunks to upload concurrently during multipart upload
// S3 supports HTTP/2 (multiplexed streams), so no practical per-origin connection limit
export const MULTIPART_CONCURRENCY = 4;
